import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "FullscreenPopup" }
const _hoisted_2 = { class: "FullscreenPopup__header" }
const _hoisted_3 = { class: "FullscreenPopup__header-title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", _hoisted_2, [
      _createVNode("button", {
        class: "FullscreenPopup__header-back-button",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_Icon, {
          type: _ctx.IconType.IC_24_LEFT,
          size: 18
        }, null, 8, ["type"])
      ]),
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}